"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _cryptoJs = _interopRequireDefault(require("crypto-js"));

var encryptByDES = function encryptByDES(m, k) {
  var keyHex = _cryptoJs["default"].enc.Utf8.parse(k);

  var encrypted = _cryptoJs["default"].DES.encrypt(m, keyHex, {
    mode: _cryptoJs["default"].mode.ECB,
    padding: _cryptoJs["default"].pad.Pkcs7
  });

  return encrypted.ciphertext.toString();
};

var encryptByAES = function encryptByAES(m, k) {
  var keyHex = _cryptoJs["default"].enc.Utf8.parse(k);

  var encrypted = _cryptoJs["default"].AES.encrypt(m, keyHex, {
    mode: _cryptoJs["default"].mode.ECB,
    padding: _cryptoJs["default"].pad.Pkcs7
  });

  return encrypted.ciphertext.toString();
};

var _default = {
  encryptByAES: encryptByAES,
  encryptByDES: encryptByDES
};
exports["default"] = _default;